import * as React from "react";
import { Component } from "react";
import { Alert, Button, Col, ControlLabel, Form, FormControl, FormGroup } from "react-bootstrap";
import "src/css/components/auth/loginform.css";
import { TIMEOUT } from "src/global";
import { ILoginProps, ILoginState } from "./interfaces";

export default class LoginForm extends Component<ILoginProps, ILoginState> {
  public constructor(props: ILoginProps) {
    super(props);

    this.state = {
      email: "",
      password: "",
      error: null,
      loading: true,
      showAlert: false,
    };

    this.submitLogin = this.submitLogin.bind(this);
    this.handleEmailChanged = this.handleEmailChanged.bind(this);
    this.getEmailValidationState = this.getEmailValidationState.bind(this);
    this.handlePasswordChanged = this.handlePasswordChanged.bind(this);
    this.getPasswordValidationState = this.getPasswordValidationState.bind(this);

    this.handleDismissError = this.handleDismissError.bind(this);
  }

  public componentDidMount() {
    this.setState({ loading: false });
  }

  public render() {
    const alertMessage = this.state.showAlert ? (
      <Alert bsStyle="danger" onDismiss={this.handleDismissError}>
        <p>{this.state.error}</p>
        <Button bsStyle="warning" bsSize="small" onClick={this.handleDismissError}>
          Dismiss
        </Button>
      </Alert>
    ) : null;

    const labelSize = 3;
    const inputSize = 9;
    return (
      <Form id="loginForm" horizontal={true} onSubmit={this.submitLogin}>
        {alertMessage}
        <FormGroup controlId="email" validationState={this.getEmailValidationState()}>
          <Col componentClass={ControlLabel} sm={labelSize}>
            Email
          </Col>
          <Col sm={inputSize}>
            <FormControl
              className="login-input"
              type="email"
              value={this.state.email}
              placeholder="Enter Email"
              onChange={this.handleEmailChanged}
            />
            <FormControl.Feedback />
          </Col>
        </FormGroup>
        <FormGroup controlId="password" validationState={this.getPasswordValidationState()}>
          <Col componentClass={ControlLabel} sm={labelSize}>
            Password
          </Col>
          <Col sm={inputSize}>
            <FormControl
              className="login-input"
              type="password"
              value={this.state.password}
              placeholder="Password"
              onChange={this.handlePasswordChanged}
            />
            <FormControl.Feedback />
          </Col>
        </FormGroup>
        <FormGroup id="loginButton" className="btn-login">
          <Col smOffset={labelSize} sm={inputSize}>
            <Button type="submit" className="login-btn">
              Login
            </Button>
          </Col>
        </FormGroup>
      </Form>
    );
  }

  private submitLogin(e: any) {
    e.preventDefault();
    setTimeout(() => {
      this.props.updateLoginState(true);
    }, 150);
    const { appService } = this.props;
    appService
      .login(this.state.email, this.state.password)
      .then(userCredential => {
        this.props.setUser(userCredential.user);
      })
      .catch(error => {
        this.setState({ error: error.message, showAlert: true });
      });
    setTimeout(() => {
      this.props.updateLoginState(false);
    }, TIMEOUT);
  }
  private getEmailValidationState() {
    const length = this.state.email.length;
    if (length === 0) {
      return null;
    }
    if (this.state.email.indexOf("@") !== -1) {
      return "success";
    } else if (this.state.email.indexOf("@") === -1) {
      return "error";
    }
    return null;
  }
  private getPasswordValidationState() {
    const length = this.state.password.length;
    if (length === 0) {
      return null;
    }
    let pwdState = "weak";
    if (length > 12) {
      pwdState = "strong";
    } else if (length > 8) {
      pwdState = "medium";
    }
    if (pwdState === "weak") {
      return "error";
    } else if (pwdState === "medium") {
      return "warning";
    } else {
      return "success";
    }
  }
  private handleEmailChanged(e: any) {
    this.setState({ email: e.target.value });
  }
  private handlePasswordChanged(e: any) {
    this.setState({ password: e.target.value });
  }
  private handleDismissError() {
    this.setState({ error: null, showAlert: false });
  }
}



// WEBPACK FOOTER //
// ./src/components/auth/LoginForm.tsx